export const formatFilterNumber = (raw: string): string => {
  if (!raw) return '';
  const n = parseInt(raw, 10);
  return isNaN(n) ? '' : n.toLocaleString('ro-RO');
};

export const parseFilterNumber = (input: string): string => input.replace(/[^0-9]/g, '');
